/* Naturealm Learn: When to Take It. Builds a daily plan from picked mushrooms + workout time. */
(function () {
  var root = document.querySelector('[data-tt]');
  if (!root) return;
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  // Guidance mirrors /blogs/news/best-time-mushroom-supplements-max-benefits
  var M = {
    s7:     { name: 'Sacred 7', slot: 'morning', why: 'All seven mushrooms in one serving. Stir one level teaspoon into coffee, or take 3 capsules with breakfast.', shop: ['Shop Sacred 7', '/products/sacred-7-medicinal-mushroom-extract'] },
    lm:     { name: 'Lion’s Mane', slot: 'morning', why: 'Studied for focus and memory, so a morning dose lines it up with your workday. It pairs well with coffee.', shop: ['Shop Lion’s Mane', '/products/lions-mane-mushroom-extract-capsules'] },
    cord:   { name: 'Cordyceps', slot: 'morning', workout: true, why: 'Studied for energy and endurance. Trials tested daily use, so any consistent time works.', shop: ['In Sacred 7', '/products/sacred-7-medicinal-mushroom-extract'] },
    chaga:  { name: 'Chaga', slot: 'morning', why: 'Antioxidant support. It isn’t stimulating or sedating, and its earthy flavor works in coffee or tea.', shop: ['Shop Chaga Tincture', '/products/chaga-mushroom-inonotus-obliquus-tincture'] },
    tt:     { name: 'Turkey Tail', slot: 'meal', why: 'Studied for immune and gut health. Benefits build with daily use, not a time of day.', shop: ['In Sacred 7', '/products/sacred-7-medicinal-mushroom-extract'] },
    sm:     { name: 'Shiitake or Maitake', slot: 'meal', why: 'Studied for immune support. Take them with a meal.', shop: ['In Sacred 7', '/products/sacred-7-medicinal-mushroom-extract'] },
    reishi: { name: 'Reishi', slot: 'evening', why: 'Studied for calm, stress, and sleep. Two droppers in a warm mug of tea makes an easy wind-down.', shop: ['Shop Reishi Tincture', '/products/reishi-tincture'] }
  };
  var CAUTION = {
    reishi: 'Reishi may add to the effect of blood thinners and blood pressure medications. Stop it before surgery.',
    chaga: 'Chaga is high in oxalates, which matters if you’ve had kidney stones, and it may affect blood sugar and clotting.',
    sm: 'Maitake is studied for blood sugar, so check first if you take diabetes medication.',
    s7: 'Sacred 7 includes Reishi, Chaga, and Maitake, so the notes for those apply too: blood thinners, blood pressure and diabetes medication, and kidney stones.'
  };
  var GENERAL = 'Check with your provider first if you’re pregnant or breastfeeding, take immune-suppressing drugs, or have surgery coming up.';

  var picked = { s7: true };
  var workout = 'none';
  var slots = {};
  $$('[data-tt-slot]').forEach(function (s) { slots[s.getAttribute('data-tt-slot')] = s; });
  var emptyEl = root.querySelector('[data-tt-empty]');
  var cautBox = root.querySelector('[data-tt-cautions]');
  var cautList = root.querySelector('[data-tt-caution-list]');

  function li(text, strong, shop, key) {
    var el = document.createElement('li');
    var b = document.createElement('strong');
    b.textContent = strong;
    el.appendChild(b);
    el.appendChild(document.createTextNode(' ' + text + ' '));
    if (shop) {
      var a = document.createElement('a');
      a.className = 'tt-shop';
      a.href = shop[1] + '?utm_source=learn&utm_medium=tool&utm_campaign=when-to-take';
      a.textContent = shop[0] + ' →';
      a.addEventListener('click', function () { push('timing_shop_click', { mushroom: key }); });
      el.appendChild(a);
    }
    return el;
  }

  function render() {
    Object.keys(slots).forEach(function (k) { slots[k].querySelector('ul').innerHTML = ''; });
    var any = false;
    Object.keys(M).forEach(function (k) {
      if (!picked[k]) return;
      any = true;
      var m = M[k];
      var slot = m.slot;
      if (m.workout && workout !== 'none') slot = 'workout';
      var why = m.why;
      if (m.workout && workout === 'pm') why = 'Studied for energy and endurance. With an afternoon or evening workout, take it beforehand rather than late at night.';
      slots[slot].querySelector('ul').appendChild(li(why, m.name + '.', m.shop, k));
    });
    Object.keys(slots).forEach(function (k) {
      slots[k].hidden = !slots[k].querySelector('li');
    });
    if (emptyEl) emptyEl.hidden = any;

    cautList.innerHTML = '';
    var c = 0;
    ['s7', 'reishi', 'chaga', 'sm'].forEach(function (k) {
      if (picked[k]) { var e = document.createElement('li'); e.textContent = CAUTION[k]; cautList.appendChild(e); c++; }
    });
    if (any) { var g = document.createElement('li'); g.textContent = GENERAL; cautList.appendChild(g); }
    cautBox.hidden = !any;
  }

  $$('[data-tt-m]').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.getAttribute('data-tt-m');
      picked[k] = !picked[k];
      b.classList.toggle('is-on', !!picked[k]);
      b.setAttribute('aria-pressed', picked[k] ? 'true' : 'false');
      render();
      push('timing_pick', { mushroom: k, on: !!picked[k] });
    });
  });
  $$('[data-tt-w]').forEach(function (b) {
    b.addEventListener('click', function () {
      workout = b.getAttribute('data-tt-w');
      $$('[data-tt-w]').forEach(function (x) {
        var on = x === b;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      render();
    });
  });

  function push(evt, data) {
    try { window.dataLayer = window.dataLayer || []; data = data || {}; data.event = evt; window.dataLayer.push(data); } catch (e) {}
  }

  // Daily reminder as a calendar file (.ics)
  var icsBtn = root.querySelector('[data-tt-ics]');
  var timeEl = root.querySelector('[data-tt-time]');
  if (icsBtn) icsBtn.addEventListener('click', function () {
    var t = (timeEl && timeEl.value) || '08:00';
    var hh = t.split(':')[0], mm = t.split(':')[1] || '00';
    var d = new Date(); d.setDate(d.getDate() + 1);
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var day = d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate());
    var names = Object.keys(M).filter(function (k) { return picked[k]; }).map(function (k) { return M[k].name; });
    var summary = 'Take ' + (names.length ? names.join(', ') : 'your mushrooms');
    var stamp = new Date().toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
    var ics = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Naturealm//When to Take It//EN', 'BEGIN:VEVENT',
      'UID:' + Date.now() + '@naturealm.co', 'DTSTAMP:' + stamp,
      'DTSTART:' + day + 'T' + hh + mm + '00', 'DURATION:PT5M', 'RRULE:FREQ=DAILY',
      'SUMMARY:' + summary.replace(/,/g, '\\,'),
      'DESCRIPTION:Consistency matters more than the clock. naturealm.co/pages/learn-when-to-take',
      'BEGIN:VALARM', 'TRIGGER:PT0M', 'ACTION:DISPLAY', 'DESCRIPTION:' + summary.replace(/,/g, '\\,'), 'END:VALARM',
      'END:VEVENT', 'END:VCALENDAR'
    ].join('\r\n');
    var blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'naturealm-daily-reminder.ics';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
    icsBtn.textContent = 'Reminder Downloaded';
    setTimeout(function () { icsBtn.textContent = 'Add Daily Reminder'; }, 2500);
    push('timing_reminder', { time: t, count: names.length });
  });

  render();
})();
